import * as React from "react";
const SvgFiRrBucket = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bucket_svg__a)">
      <path
        fill="#062147"
        d="M22 8.002h-.63A9.52 9.52 0 0 0 15.484.673 1.99 1.99 0 0 0 14 .002h-4c-.592 0-1.118.262-1.484.671a9.52 9.52 0 0 0-5.885 7.329h-.63a1 1 0 1 0 0 2h.692L4.846 20.05a5.026 5.026 0 0 0 4.889 3.952h4.532a5.03 5.03 0 0 0 4.89-3.952l2.153-10.048h.692a1 1 0 1 0 0-2zM17.2 19.63a3.02 3.02 0 0 1-2.935 2.372H9.733a3.016 3.016 0 0 1-2.934-2.372l-1.206-5.628h9.906a1 1 0 1 0 0-2H5.165l-.429-2h14.527zM4.651 8.002a7.52 7.52 0 0 1 3.625-5.001 1.99 1.99 0 0 0 1.723 1.001h4a1.99 1.99 0 0 0 1.723-1.001 7.52 7.52 0 0 1 3.626 5.002H4.651z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bucket_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBucket;
